import * as Yup from "yup";

export const loginOtpValidate = Yup.object().shape({
  mobile: Yup.string()
    .required("وارد کردن شماره همراه الزامیست")
    .min(11, "شماره همراه باید 11 رقمی باشد!")
    .max(11, "شماره همراه باید 11 رقمی باشد!"),
  code: Yup.string()
    .required("وارد کردن کد الزامیست")
    .min(6, "کد باید 6 رقمی باشد!")
    .max(6, "کد باید 6 رقمی باشد!"),
  password: Yup.string().required("وارد کردن رمز عبور الزامیست"),
});

export const loginGoogleTotpValidate = Yup.object().shape({
  mobile: Yup.string()
    .required("وارد کردن شماره همراه الزامیست")
    .min(11, "شماره همراه باید 11 رقمی باشد!")
    .max(11, "شماره همراه باید 11 رقمی باشد!"),
  password: Yup.string().required("وارد کردن رمز عبور الزامیست"),
});
